module.exports = __webpack_public_path__ + "img/category-favorite.23baa0a4.png";